module.exports = new __parcel__URL__("pl_3.71278cad.png").toString();